import React, { Fragment, useState } from 'react';

import styled from 'styled-components';
import { Tree } from 'antd';

import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

const { TreeNode } = Tree;

const StyledTree = styled(Tree)``;

const StyledCard = styled.div`
  color: ${colors.DARKEST_GRAY};
  border-radius: 20px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.125);
  text-align: left;
  padding: 16px;
  background: #ffffff;
  max-height: 450px;

  ${media.mobile`
    padding: 16px;
  `};
`;

const StyledTreeContainer = styled.div`
  max-height: 425px;
  overflow-y: scroll;
`;

const StyledTreeNode = styled(TreeNode)`
  width: 100%;
`;

const StyledEmptyText = styled.span``;

const treeNodesMap = (data, checkedKeys, name) => {
  return data.map(item => {
    if (!item.children) return <StyledTreeNode title={item.title} key={item.key} dataRef={item} />;

    return (
      <StyledTreeNode title={item.title} key={item.key} dataRef={item}>
        {treeNodesMap(item.children, checkedKeys, name)}
      </StyledTreeNode>
    );
  });
};

const SelectedBreakdown = ({ breakdown, selected, handleSelect, name }) => {
  const [checkedKeys, setCheckedKeys] = useState(selected);

  const onCheck = checkedKeys => {
    const nameSpaceCheck = name + '_';
    const propertyIds = checkedKeys.filter(word => word.startsWith(nameSpaceCheck));
    handleSelect(propertyIds);
    setCheckedKeys(checkedKeys);
  };

  return (
    <Fragment>
      <StyledCard>
        {selected && selected.length > 0 ? (
          <StyledTreeContainer>
            <StyledTree
              checkable
              selectable={false}
              onCheck={selected => onCheck(selected)}
              checkedKeys={checkedKeys}
            >
              {treeNodesMap(breakdown, checkedKeys, name)}
            </StyledTree>
          </StyledTreeContainer>
        ) : (
          <StyledEmptyText>
            {getTranslatedString(`landlordPortal.reviewSelected.emptyState.${name}`)}
          </StyledEmptyText>
        )}
      </StyledCard>
    </Fragment>
  );
};

export default SelectedBreakdown;
